import React from 'react'; 
import './Hours.css'; 
import './Home.css'; 
import 'aos/dist/aos.css'; 
import '../The-Gallery/Visit-Us/Visit-Us.css'; 

function Stuff() {

    return (
        <div id="stuff"> 
          <h1 className="sub-stuff">Check Out Our Online Shop</h1> 
          <h3 className="paragraph-stuff">
              From abstract expressionism to excentric pop art, we want to allow you to find 
              yourself a unique work that resonates with you! The contents of the online shop 
              are limited, with each painting being the only one of its kind, but waste no more 
              time reading about it when you can come find out for yourself! 
              </h3> 
        </div>
    );
  }
  
  export default Stuff;